(function ($) {

    var owlBusiness =   $('.owl-carousel-forbusiness');
    var owlFamily =   $('.owl-carousel-forfamily');
    var owlFaq =  $('.owl-carousel-faq');
    var owlNews =  $('.news-carousel');
    var isMobile = window.matchMedia("(max-width: 767px)").matches;

    var owlBusinessOptions = {
        loop: false,
            margin: 0,
        responsiveClass: true,
        dots: false,
        //dotsData: true,
        dotsEach: false,
        nav: false,
        touchDrag: true,
        mouseDrag: true,
        responsive: {
        0: {
            items: 1
        },
        500: {
            items: 1
        },
        600: {
            items: 2
        },
        1000: {
            items: 2
        },
        1400: {
            items: 2
        },
        1500: {
            items: 2
        },
        1600: {
            items: 2
        }
    }
    };

    var owlFamilyOptions = {
        loop: false,
        margin: 0,
        responsiveClass: true,
        dots: false,
        //dotsData: true,
        dotsEach: false,
        nav: false,
        touchDrag: true,
        mouseDrag: true,
        responsive: {
            0: {
                items: 1
            },
            500: {
                items: 1
            },
            600: {
                items: 1
            },
            992: {
                items: 2
            },
            1400: {
                items: 2
            },
            1500: {
                items: 2
            },
            1600: {
                items: 2
            }
        }
    };


    var owlFaqOptions = {
        loop: false,
        margin: 0,
        responsiveClass: true,
        dots: false,
        //dotsData: true,
        dotsEach: false,
        nav: false,
        touchDrag: true,
        mouseDrag: true,
        responsive: {
            0: {
                items: 2
            },
            400: {
                items: 2
            },
            500: {
                items: 2
            },
            600: {
                items: 3
            },
            700: {
                items: 3
            },
            800: {
                items: 3
            },
            900: {
                items: 3
            },
            1000: {
                items: 4
            },
            1100: {
                items: 5
            },
            1400: {
                items: 5
            },
            1500: {
                items: 6
            },
            1600: {
                items: 6
            }
        }
    };

    var owlNewsOptions = {
        loop: true,
        margin: 0,
        responsiveClass: true,
        dots: false,
        dotsEach: false,
        nav: true,
        navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
        touchDrag: true,
        mouseDrag: false,
        responsive: {
            768: {
                items: 2
            },
            1200: {
                items: 3
            },
        }
    };


    $(window).bind("load", function () {
         if($(window).width() > 1000){
            owlBusinessOptions.mouseDrag = false;
            owlBusinessOptions.touchDrag = false;

            owlFamilyOptions.mouseDrag = false;
            owlFamilyOptions.touchDrag = false;
        }

        if($(window).width() > 1200){
            owlFaqOptions.mouseDrag = false;
            owlFaqOptions.touchDrag = false;
        }


        var owlWynajem = $('.owl-carousel-wynajem').owlCarousel({
            loop: true,
            margin: 0,
            responsiveClass: true,
            dots: true,
            //dotsData: true,
            dotsEach: true,
            nav: false,
            responsive: {
                0: {
                    items: 1
                },

                1000: {
                    items: 2
                },
                1400: {
                    items: 2
                },
                1500: {
                    items: 2
                },
                1600: {
                    items: 2
                },
                2100: {
                    items: 3
                },
                2800: {
                    items: 4
                }
            }
        });


        owlBusiness.owlCarousel(owlBusinessOptions);

        owlFamily.owlCarousel(owlFamilyOptions);

        owlFaq.owlCarousel(owlFaqOptions);

        if (!isMobile) {
            owlNews.owlCarousel(owlNewsOptions);
        }
    });



    $(window).bind("resize", function () {
        isMobile = window.matchMedia("(max-width: 767px)").matches;

        var reinitOwl = false;
        var reinitOwlFaq = false;

        if($(window).width() > 1200){
            owlFaqOptions.mouseDrag = false;
            owlFaqOptions.touchDrag = false;

            if(owlFaqOptions.mouseDrag !== false){
                reinitOwlFaq = true;
            }
        } else {
            if(owlFaqOptions.mouseDrag !== true){
                reinitOwlFaq = true;
            }
            owlFaqOptions.mouseDrag = true;
            owlFaqOptions.touchDrag = true;
        }


        if($(window).width() > 1000){
            if(owlBusinessOptions.mouseDrag !== false){
                reinitOwl = true;
            }
            owlBusinessOptions.mouseDrag = false;
            owlBusinessOptions.touchDrag = false;

            owlFamilyOptions.mouseDrag = false;
            owlFamilyOptions.touchDrag = false;


        } else {
            if(owlBusinessOptions.mouseDrag !== true){
                reinitOwl = true;
            }
            owlBusinessOptions.mouseDrag = true;
            owlBusinessOptions.touchDrag = true;

            owlFamilyOptions.mouseDrag = true;
            owlFamilyOptions.touchDrag = true;
        }

        if(reinitOwl){
            owlBusiness.owlCarousel('destroy');
            owlBusiness.owlCarousel(owlBusinessOptions);

            owlFamily.owlCarousel('destroy');
            owlFamily.owlCarousel(owlFamilyOptions);

        }

        if(reinitOwlFaq){
            owlFaq.owlCarousel('destroy');
            owlFaq.owlCarousel(owlFaqOptions);
        }

        if(owlNews.data('owl.carousel') && isMobile){
            owlNews.owlCarousel('destroy');
        }

        if(!owlNews.data('owl.carousel') && !isMobile){
            owlNews.owlCarousel(owlNewsOptions);
        }


    });

})(jQuery);